export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/1.jpg'),
        title: 'enterprise strategy & transformation',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'WORK EFFICIENCY AND REDUCE OPERATION COSTS',
      description: `<p style="font-size:1.5rem">Business Transformation is a management strategy that implies a strategic change with the aim to align both the organization and the individuals in it more closely with the company's business strategy and vision. This change is a crucial part of any modernization program, but also necessary to survive in the increasingly competitive global market.
In today's ever changing global economy, many companies change their business model in order to grow, stay competitive and meet their clients' needs. This transformation can be the result of external factors and you will need an experienced partner to help you achieve your business strategy and vision.
</p><p>MaesInfo has extensive experience and helps its clients formulate and implement a winning business strategy & transformation. Many companies have turned to us for strategic direction and help towards achieving their corporate vision.
We have the expertise, the vision and the problem-solving techniques to help you effectively implement and execute your strategy & transformation.
</p>`
    },
    {
      title: 'HOW MAESINFO CAN HELP YOUR BUSINESS:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/2.jpg')+`)"></span>
      <span class="list">
      <i></i> Analysis of your products and the market with the goal making the most of
 your company's market opportunities <br/>
      <i></i>Enterprise planning<br/>
      <i></i>Business unit strategy<br/>
      <i></i>Portfolio strategy<br/>
      <i></i>Growth strategy<br/>
      <i></i>Innovation, diversification and commercialization<br/>
      <i></i>Clinical research strategy<br/>
      <i></i>Inorganic growth strategy <br/>
      <i></i>Identifying and building a customer strategy, imrpoving your customer
     interaction
      </span>`
    }
  ]
}
